<template>
  <tender-form-label :key="index" :label="options.Name" :prop="options.Key" :rules="rules">
    <span class="span-areacode" @click.native="showDlgArea">{{ form[options.Key] }}</span>
    <el-dialog title="对严重失信行为作出裁决或行政处罚的主管部门行政区域" v-model="addressDialog" append-to-body width="50%">
      <wce-multi-region
        ref="multiRegion"
        :regionInfoCode="regionInfoCode"
        :regionsClearable="regionsClearable"
        :isAll="false"
        @regionInfo="getRegionInfo"></wce-multi-region>
      <template #footer>
        <span slot="footer" class="dialog-footer">
          <el-button @click="addressDialog = false">取 消</el-button>
          <el-button type="primary" @click="ensure">确 定</el-button>
        </span>
      </template>
    </el-dialog>
  </tender-form-label>
</template>
<script>
import { mixForFormItem } from "../../../js/mixins";
import utils from "../../../js/utils";
import WceMultiRegion from "~@/multi-region/src";
export default {
  name: "FormInputRegionQz",
  mixins: [mixForFormItem],
  components: { WceMultiRegion },
  data() {
    return {
      addressDialog: false,
      regionInfoCode: {
        regionPro: "350000",
        regionCity: "",
        regionCounty: "",
      },
      regionsClearable: {
        city: true,
        county: true,
      },
      regionInfo: {},
    };
  },
  created() {
    this.setDefaultValue();
  },
  methods: {
    init() {
      let { form = {}, options, regionInfoCode } = this;
      utils.readyToSetFormItemDefault(form, options).then(() => {
        let str = form.HM_REGION_CODE || form.regionId;

        form.HM_REGION_CODE = str;
        if (str.includes("00")) {
          form.HM_REGION_CODE = regionInfoCode.regionCity = form.HM_REGION_CODE || form.regionId;
        } else {
          regionInfoCode.regionCounty = str;
          regionInfoCode.regionCity = str.substr(0, 4) + "00";
        }

        form.HM_REGION_NAME = form.HM_REGION_NAME || form.region;
      });
    },
    setDefaultValue() {
      let { form = {}, options, regionInfoCode } = this;
      utils
        .readyToSetFormItemDefault(form, options)
        .then(() => {
          // this.setFormItemValue(options.Value || "");
          let str = form.HM_REGION_CODE || form.regionId;

          form.HM_REGION_CODE = str;
          if (str.includes("00")) {
            form.HM_REGION_CODE = regionInfoCode.regionCity = form.HM_REGION_CODE || form.regionId;
          } else {
            regionInfoCode.regionCounty = str;
            regionInfoCode.regionCity = str.substr(0, 4) + "00";
          }

          form.HM_REGION_NAME = form.HM_REGION_NAME || form.region;
        })
        .catch(() => null);
    },
    inputChangeHandle() {
      this.doValidate();
    },
    showDlgArea() {
      this.addressDialog = true;
    },
    getRegionInfo(regionInfo) {
      this.regionInfo = regionInfo;
    },
    ensure() {
      for (let key in this.regionInfoCode) {
        if (this.regionInfoCode[key]) {
          this.form.HM_REGION_CODE = this.regionInfoCode[key];
          this.form.HM_REGION_NAME = this.regionInfo[key];
        }
      }
      this.addressDialog = false;
    },
  },
};
</script>
<style lang="scss" scoped>
$valueColor: #2393e4;
.span-areacode {
  display: inline-block;
  padding: 5px 5px;
  width: auto;
  min-width: 100px;
  line-height: 1;
  text-align: left;
  vertical-align: bottom;
  text-indent: 0;
  word-break: break-all;
  outline: none;
  color: $valueColor;
  border-bottom: 1px solid black;
  cursor: pointer;
}
</style>
<style lang="scss">
.is-error {
  .span-areacode {
    border-bottom-color: red;
  }
}
</style>